import * as React from 'react';
import * as format from 'date-fns/format';
import * as parse from 'date-fns/parse';

export interface DatetimeProps {
  /** ISO format date timestamp */
  at?: string | Date;
  /** date-fns/format compatible format string */
  format?: string;
  /** if this option is passed, the datetime may be imprecise if it is pre-NKBA migration */
  imprecise?: boolean;
}
const MIGRATION_CUTOFF = 1494820800000; // May 15 2017
export const Datetime: React.SFC<DatetimeProps> = (props: DatetimeProps) => {
  if (!props.at) {
    return <span>Never</span>;
  }
  let defaultFormat = 'ddd MMM D YYYY h:mm a';
  if (props.imprecise && parse(props.at).getTime() < MIGRATION_CUTOFF) {
    defaultFormat = 'ddd MMM D YYYY';
  }
  const formatStr = props.format ? props.format : defaultFormat;
  const formatted = format(props.at, formatStr);
  return <span>{formatted}</span>;
};



// WEBPACK FOOTER //
// ./src/common/components/Datetime.tsx